module.exports = __webpack_public_path__ + "img/jwgk.15157fe7.svg";